/* eslint-disable */
import * as types from '../../actions/types';

const initialState = false

export default function canTry (state = initialState, action) {
  switch (action.type) {
    
    case types.SET_TESTING_TRY:
      return action.payload

    default:
      return state;
  }
}